export default __webpack_public_path__ + "static/media/3.f18696e2.svg";